// extracted by mini-css-extract-plugin
export default {"AddressForm__required":"AddressForm_AddressForm__required__jDiNM","AddressForm__icon":"AddressForm_AddressForm__icon__7B0nE"};